import { Routes, Route } from "react-router-dom";
import Entities from "./Entities";
import AdminPlacementTest from "./AdminPlacementTest";
import { AdminProvider } from "../../context/AdminContext";
import DashboardLayout from "../../layouts/DashboardLayout";
import AdminDashboard from "./AdminDashboard";
import OurTeam from "./OurTeam";
import Programs from "./programs/Programs";
import { ProgramProvider } from "../../context/ProgramContext";
import Teacher from "./Teacher";
import Classrooms from "./Classrooms";
import Students from "./Students";
import ProfilePage from "../shared/ProfilePage";

const Admin = () => {
  return (
    <AdminProvider>
      <ProgramProvider>
        <DashboardLayout>
          <Routes>
            <Route path="/" element={<AdminDashboard />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="schools" element={<Entities />} />
            <Route path="teachers" element={<Teacher />} />
            <Route path="classrooms" element={<Classrooms />} />
            <Route path="students" element={<Students />} />
            <Route path="programs" element={<Programs />} />
            <Route path="placement-test" element={<AdminPlacementTest />} />
            <Route path="our-team" element={<OurTeam />} />
          </Routes>
        </DashboardLayout>
      </ProgramProvider>
    </AdminProvider>
  );
};

export default Admin;
